import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./FloatingSocial.scss";

const FloatingSocial = () => {
  return (
    <div className="floating-social">
      <a
        href="https://wa.me/919626188801"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-social__item floating-social__item--whatsapp"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default FloatingSocial;
